import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';
import { CurationItemId } from './curation-item-id';
import { NodeDependencies } from "@ispm/shared/bpmn/models/node-dependencies";

export interface PathwaysExecutionData {
  patientData?: any;
  bpmnIdentifier?: BpmnDeploymentIdentifier;
  nodes?: any[];
  curationItemId?: CurationItemId;
  nodeSelectionDependencies?: NodeDependencies;
}
